<template>
	<div class="pages h-full min-h-500">
		<Button type="back" url="/homepage" :name=" $t('back_button') " />
		<form class="text-center mt-16 mx-14" action="#">
			<div class="relative" v-if="photoPreview">
				<img class="mx-auto mb-5" :src="photoPreview" height="200" width="200">
				<img src="../assets/images/close-red.svg" class="absolute right-4 -top-4" alt="" @click="cancelPhoto">
			</div>
			<div class="flex flex-col gap-4">
				<div class="flex gap-2 items-center w-full">
					<label for="upload" class="bg-green-5 p-2.5 rounded-2xl w-14 h-12 flex items-center justify-center"><img class="w-full" src="../assets/images/upload.png" alt=""></label>
					<input type="file" id="upload" class="hidden" accept="image/*" @change="onSelectedFile">
					<button type="button" class="bg-white rounded-2xl w-full py-2.5 flex justify-center shadow-2xl" @click="onTakePhoto"><img src="../assets/images/camera-upload.svg" alt=""></button>
				</div>
				<input type="file" class="hidden" ref="filePhoto" accept="image/*" capture="environment" @change="onSelectedFile">
				<p v-if="loading" class="text-white">Loading...</p>
				<button type="submit" class="text-sm text-white font-bold bg-green-5 py-3 rounded-2xl" v-if="uploadButton" @click="onUpload()">Upload</button>
			</div>
			<p class="mt-5 text-xl text-white font-bold">{{ $t('receipt_title') }}</p>
			<p class="mt-2 text-sm text-white">{{ $t('receipt_note_1') }}</p>
			<p class="mt-4 text-sm text-white italic">{{ $t('receipt_note_2') }}</p>
		</form>
		<div class="pages__receipt mt-11 md:mt-14">
			<div class="text-center">
				<p class="text-lg text-white font-bold">{{ $t('receipt_store') }}</p>
				<p class="text-xs text-white font-bold">6-3-2022</p>
			</div>
			<div class="mt-14">
				<div class="flex justify-between items-center">
					<p class="text-xs text-white">{{ $t('receipt_item') }}</p>
					<p class="text-xs text-white">{{ $t('receipt_qty') }}</p>
				</div>
				<div class="flex justify-between items-center">
					<p class="text-xs text-white">{{ $t('receipt_gum') }} Doublemint</p>
					<p class="text-xs text-white">1</p>
				</div>
				<div class="border-2 border-yellow-1 rounded mt-8"></div>
				<div class="flex justify-between items-center mt-2">
					<p class="text-xs text-white">{{ $t('receipt_total') }}</p>
					<p class="text-sm font-black text-white">{{ $t('receipt_extra') }}</p>
				</div>
				<div class="mt-5">
					<p class="text-xs text-white">{{ $t('receipt_reminder') }}</p>
					<ul>
						<li class="text-xs text-white">{{ $t('receipt_reminder_desc_1') }}</li>
						<li class="text-xs text-white">{{ $t('receipt_reminder_desc_2') }}</li>
						<li class="text-xs text-white">{{ $t('receipt_reminder_desc_3') }}</li>
						<li class="text-xs text-white">{{ $t('receipt_reminder_desc_4') }}</li>
					</ul>
				</div>
			</div>
		</div>
		<div @click="$parent.sfx.touch.play()">
			<router-link to="terms-and-condition">
				<span class="my-3.5 text-sm font-bold text-yellow-1 text-center block underline">*{{ $t('homepage_modal_terms') }}</span>
			</router-link>
		</div>
	</div>
</template>

<script>
import { collection, onSnapshot, query, where } from "firebase/firestore"
import { auth, firestore } from "../firebase/firebaseInit"
import { mapActions, mapState } from "vuex"
import Button from '@/components/Button.vue'

let listener

export default {
	metaInfo() {
		return {
			title: "Receipt"
		};
	},
	name: 'Receipt',
	components: {
		Button,
	},
  	computed: {
		...mapState([
			"loading",
			"uploadButton",
			"photoPreview"
		])
	},
	data () {
		return {
			hasUploadedReceipt: false
		}
    },
	methods: {
		...mapActions([
			"onSelectedFile",
			"uploadReceipt",
			"cancelPhoto"
		]),
		userProfile() {
			const profilesQuery = query(
				collection(firestore, `users`),
				where("id", "==", auth.currentUser.uid)
			)
			listener = onSnapshot(profilesQuery, (query) => {
				query.docs.map((data) => {
					this.hasUploadedReceipt = data.data().has_uploaded_receipt
					if (data.data().has_uploaded_receipt) { 
						this.$store.commit('SET_LOADING', false)
						alert('File upload successful')
						this.$router.replace({ name: 'Homepage' })
					}
				})
			})
		},
		playSound(sound) {
			this.$parent.sfx.touch.play()
		},
		onTakePhoto() {
			this.$refs.filePhoto.click()
		},
		async onUpload() {
			await this.uploadReceipt(this.hasUploadedReceipt)
		},
		stopListener() {
			listener()
		}
	},
	created() {
		this.userProfile()
		this.$store.commit("RESET_PHOTO_PREVIEW")
    },
	beforeRouteLeave(to, from, next) {
		this.$store.commit('RESET_PHOTO_PREVIEW')
		this.$store.commit('RESET_SELECTED_FILE')
		this.stopListener()
		next()
	}
}
</script>
